import { CSSProperties, ChangeEvent, useState } from 'react';
import { Input } from 'antd';
import classNames from 'classnames';
import Radio, { RadioProps } from '@components/common/Radio/Radio';
import { useViewport } from '@hooks/viewport';
import './DataFilterPanel.scss';

type filterOption = Pick<RadioProps, 'label' | 'value' | 'disabled' | 'style'>;
interface DataFilterPanelProps {
  dataTotalCount: number;
  filterOptions?: filterOption[];
  keywordPlaceholder?: string;
  filterChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onSearch?: (e: string) => void;
  style?: CSSProperties;
}

const DataFilterPanel: React.FC<DataFilterPanelProps> = (props) => {
  const { dataTotalCount, filterOptions, keywordPlaceholder, filterChange, onSearch } = props;
  const { isMobile } = useViewport();
  const [searchValue, setSearchValue] = useState('');
  const [selectedFilter, setSelectedFilter] = useState(filterOptions?.[0]?.value);

  const handleSearch = (val: string, type?: 'input' | 'clear') => {
    if (type === 'input') {
      setSearchValue(val);
      onSearch && onSearch(val);
    }
  };

  const handleFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedFilter(e.target.value);
    filterChange && filterChange(e);
  };

  return (
    <div className="filter-panel" style={props.style}>
      <div className="filter-panel__count">
        목록 <span className="filter-panel__count--red">{dataTotalCount}</span>개
      </div>
      <div className={classNames(`filter-panel__filter`, isMobile && 'mobile')}>
        {filterOptions && filterOptions.length > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', marginRight: '22px' }}>
            <Radio.Group
              keyName="sort"
              options={filterOptions}
              defaultChecked={selectedFilter}
              onChange={handleFilterChange}
            />
          </div>
        )}
        {onSearch && (
          <Input.Search
            size="large"
            placeholder={keywordPlaceholder}
            enterButton="검색"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onSearch={(val, _, info) => handleSearch(val, info?.source)}
            style={isMobile ? { width: '100%' } : {}}
          />
        )}
      </div>
    </div>
  );
};

export default DataFilterPanel;
